// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ec61fef2","160":"b16d7a5d","208":"206fd358","293":"4bc5906f","453":"36ec7b51","516":"be4349ef","519":"8ffde2d6","917":"8251ff12","946":"ac471ef6"}[chunkId] + ".chunk.js";
};